<template>
    <div class="detail">
        <div class="box_title">
            <div class="box_title_left">
                {{ name }}
            </div>
            <div class="box_title_right">
               <span class="el-icon-location-outline"></span> 当前位置:  <router-link to="/"> 首页 </router-link> /  {{ name }} 
            </div>
        </div>

        <div class="content_box">
            
               <!-- 选择的章节详情 -->
               <div class="studyInfo_box">
                   <div class="title">{{ info.subTitle }}</div>
               </div>
               <div class="video_box" v-if="DetailInfo && DetailInfo.video">
                   <div class="left">
                       <video class="study_video" :src="DetailInfo.video[0]" v-if="DetailInfo.video[0] && DetailInfo.video[0].indexOf('http') != -1" controls  autoplay ></video>
                       <video class="study_video" :src="$ImgUrl + DetailInfo.video[0]" v-else controls  autoplay></video>
                   </div>
                   <div class="right">
                       <!-- 主讲人信息 -->
                       <div class="user_box">
                           <div class="top">
                               <div class="avatar">
                                   <img :src="info.authorImg" v-if="info.authorImg && info.authorImg.indexOf('http') != -1">
                                   <img :src="$ImgUrl + info.authorImg" v-else>
                               </div>
                               <div class="username">主讲人: {{ info.author }}</div>
                           </div>
                           <div class="desc">
                               <span>{{ info.authorBrief }}</span>
                           </div>
                       </div>
                       <!-- 目录 -->
                       <div class="mulu_box">
                           <div class="mulu_title">课程目录</div>
                           <div class="mulu_list">
                               <div class="mulu" v-for="(item, index) in MuLuList" :key="index" @click="showZhangJie(item, index)">
                                   <div class="zj" :class="MuLuIndex == index ? 'white' : 'gray'  ">
                                       {{ index + 1 }}: {{ item.title }}
                                   </div>
                                   <div class="img_box">
                                       <img v-if="MuLuIndex == index" src="../../assets/static/zhibu/playying.gif" alt="">
                                   </div>
                               </div>
                           </div>
                       </div>
                   </div>
               </div>

               <!-- 简介 -->
               <div class="biref">
                   <div class="b_title">
                       课程简介
                   </div>
                   <div class="user">
                       <div class="left">
                           <img :src="info.authorImg" v-if="info.authorImg && info.authorImg.indexOf('http') != -1">
                           <img :src="$ImgUrl + info.authorImg" v-else>
                       </div>
                       <div class="right">
                           <div class="username">{{ info.author }}</div>
                           <div class="desc">{{ info.authorBrief }}</div>
                       </div>
                   </div>
                   <div class="info_biref">
                       {{ DetailInfo.brief  }}
                   </div>
               </div>

            <!-- 推荐 -->
            <div class="bottom_box">
                <div class="tuijian_title">
                    大家都在看
                </div>
                <div class="list_content">
                    <div class="list_item" v-for="(item, index) in tuiJian" :key="index" @click="showStudyInfo( item )">
                        <img :src="item.img" v-if="item.img && item.img.indexOf('http') != -1" alt="">
                        <img :src="$ImgUrl + item.img" v-if="item.img && item.img.indexOf('http') == -1" alt="">
                        <img src="../../assets/static/index/default.png" v-if="!item.img" alt="">
                        <div class="item_title">
                            {{ item.subTitle }}
                        </div>
                        <div class="item_bar">
                            <div class="time">
                               <span class="el-icon-reading"></span> 课程: {{ item.count }}节
                            </div>
                            <div class="show_btn">
                                <span class="el-icon-right"></span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

                <!-- 悬浮按钮 -->
                <div class="fixed_box">
                    <div class="item"  v-for="(item, index) in iconList" 
                    :key="index" :class="active === index ? 'active': ''  "
                    @mouseover="MouseEnter( index )"
                    @mouseout="MouseOut"
                    @click="itemClick( index )"
                     >
                        <span :class="item.status == 1 ? item.activeClass : item.iconClass  "></span>
                        <span class="txt" v-if="item.count && item.count != '0' ">{{ item.count }}</span>
                    </div>
                    
                </div>

        </div>

    </div>
</template>

<script>
    import { mapGetters } from "vuex"
    export default {
        data() {
            return {
                name: "红色学堂",
                content: `<div>这里是文章内容</div>`,
                iconList: [
                    { iconClass: "icon iconfont icon-shoucang gray", activeClass: "icon iconfont icon-shoucang red", count: 0, status: 0 },
                    // { iconClass: "icon iconfont icon-dianzan gray",activeClass: "icon iconfont icon-dianzan red", count: 0, status: 0 },
                    { iconClass: "icon el-icon-share red",activeClass: "icon el-icon-share red", count: 0,status: 1 },
                    { iconClass: "icon el-icon-top red",activeClass: "icon el-icon-top red", count: 0,status: 1 },
                ],
                active: "",  
                timer: "", // 定时器
                second: 0, // 秒
                MuLuIndex:0,
                tuiJian: [],
            }
        },

        props: {
            info: Object,
            MuLuList: Array,
            isZan: {
                type: Number,
                default: 0
            },
            isCollect: {
                type: Number,
                default:0
            },
           
        },
        computed: {
            DetailInfo() {
                return this.MuLuList[this.MuLuIndex]
            },
            subId () {
                return Number( this.$route.params.id)
            },
            ...mapGetters(['token'])
        },
        watch: {
            school_id () {
                // this.timeCount()
            },
            isCollect () {
                this.formatData()
            },
            
            
        },
        mounted() {
            this.formatData()
            this.getTuiList()
            setTimeout(() => {
                this.StudyCount()
            }, 500);
        },

        methods: {
            // 点击章节
            showZhangJie(item, index) {
                this.MuLuIndex = index
                this.StudyCount()
            },

            // 增加学习次数
            // 学习次数
			async StudyCount() {
                let { token, subId } = this 
                console.log( this.DetailInfo )
				let { sd_id } = this.DetailInfo
				let res = await this.$axios.post("/lencon/pc/school/school/readNumPlus", { token, subId, sd_id })
			},
           
            // 鼠标进入事件
            MouseEnter ( index ) {
                this.active = index 
            },
            // 鼠标离开
            MouseOut () {
                this.active = ""
            },
            // 点击事件
            itemClick ( index ) {
                if (index == 2) {
                    this.scrollTop()
                } else if ( index == 0 && this.token ) {
                    this.collectNews()
                } else if ( index == 1 && this.token ) {
                    this.shareNews()
                    
                } 
            },
             // 故不能动到顶部
            scrollTop () {
                document.documentElement.scrollTop = 0
            },
             // 分享链接
            shareNews () {
                this.shareUrl = window.location.href
                const input = document.createElement('input');
                document.body.appendChild(input);
                input.setAttribute('value', this.shareUrl );
                input.select();
                if (document.execCommand('copy')) {
                    document.execCommand('copy');
                    this.$message.success("复制成功")
                }
                document.body.removeChild(input);
            },
            // 收藏
            async  collectNews () {
                let { token,subId } = this 
                console.log(subId )
                let res = await this.$axios.post("/lencon/pc/school/school_collection", { token, school_id:subId })
                this.$message.success("操作成功" )
                this.$emit('update')
            },
            // 获取推荐列表
            async getTuiList() {
                let { token, subId } = this 
                let res = await this.$axios.post("/lencon/pc/school/schoolList", { token,type:subId ,pageNum:1,pageSize:4,cate: 1})
                if ( res.data.code == 1 ) {
                    this.tuiJian = res.data.data
                }
            },
            // 点赞
            // async  zanNews () {
            //     let { token,news_id } = this 
            //     let status = this.isZan == 1 ? 1 : 0
            //     let res = await this.$axios.post("/lencon/pc/news/news/zan", { token, news_id: news_id, status })
            //     this.$message.success( res.data.msg )
            //     this.$emit('update')
            // },
            // 滚动到顶部
            scrollTop () {
                document.documentElement.scrollTop = 0
            },
            // 展示新闻详情
            showNewsDetail ( item ) {
                this.$router.push({
                    path: `/NewsDetail/${item.newsId}`,
                    query: {
                        cate_id: item.cate_id
                    }
                })
            },
            // 格式化数据
            formatData () {
                    this.iconList[1].status = this.isZan
                    this.iconList[0].status = this.isCollect
                    this.iconList[1].count = this.info.zanNum
                // console.log( this.info )
            },
            // 进入学习详情
            async showStudyInfo ( item ) {
                this.$router.push(`/studyDetail/${ item.subId }`)
            },
        },
        updated() {
            this.formatData()
        },
    }
</script>

<style lang="scss" scoped>
@import "../../assets/css/main.scss";


.detail {
    width: 1200px;
    min-height: 700px;
    margin: 20px auto;
    .box_title {
        color: #fff;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding-left: 20px;
        border-left: 4px solid #fff;
        margin: 20px 0;
        .box_title_left {
            font-size: 24px;
            font-weight: bold;
        }
        .box_title_right {
            font-size: 14px;
        }
    }
    .content_box {
        width: 1200px;
        padding: 40px;
        background-color: #fff;
        position: relative;
        left: 0;
        top: 0;
        .fixed_box {
            position: fixed;
            box-shadow: 0 0 10px 2px #eee;
            top: 370px;
            left: 200px;
            background-color: #fff;
            width: 100px;
            border-radius: 5px;
            // border: 1px solid #EDEDED;
            overflow: hidden;
            .item {
                padding: 20px 10px;
                text-align: center;
                cursor: pointer;
                .red {
                    color: #2767c4 ;
                    
                }
                .gray {
                    color: #b3b3b3 ;
                }
            }
            .active {
                background-color: #2767c4 ;
                color: #ffffff !important;
                .icon {
                    color: #fff;
                }
            }
        }
        .studyInfo_box {
            width: 100%;
           .title {
               width: 100%;
               font-size: 24px;
               line-height: 60px;
               text-align: left;
           }
           
        }
        .video_box {
               width: 100%;
               display: flex;
               .left{
                   width: 70%;
                   video {
                       width: 100%;
                       height: 440px;
                   }
               }
               .right {
                   width: 30%;
                   height: 440px;
                   background: rgb(74, 74, 74);
                   .user_box {
                       width: 100%;
                       background: rgb(85, 85, 85);
                       .top {
                           width: 100%;
                           padding: 20px;
                           display: flex;
                           align-items: center;
                           .avatar {
                               width: 60px;
                               height: 60px;
                               border-radius: 50%;
                               overflow: hidden;
                               img {
                                   width: 60px;
                                   height: 60px;
                               }
                           }
                           .username {
                               color: #ffffff;
                               width: 50%;
                               margin-left: 20px;
                           }
                       }
                       .desc {
                           padding: 10px;
                           font-size: 14px;
                           color: #B9B8B8;
                           span {
                               overflow: hidden;
                               text-overflow: ellipsis;
                               white-space: nowrap;
                           }
                       }
                   }
                   .mulu_box {
                       width: 100%;
                       max-height: 300px;
                       overflow-y: scroll;
                       &::-webkit-scrollbar {
                           display: none;
                       }
                       .mulu_title {
                           line-height: 30px;
                           font-size: 16px;
                           padding: 0 10px;
                           color: #fff;
                           font-weight: bold;
                       }
                       .mulu_list {
                           width: 100%;
                           .mulu {
                               width: 100%;
                               display: flex;
                               align-items: center;
                               padding: 10px;
                               .zj {
                                   flex: 1;
                                   overflow: hidden;
                                   text-overflow: ellipsis;
                                   white-space: nowrap;
                                   cursor: pointer;
                               }
                               .white {
                                   color: #ffffff;
                               }
                               .gray {
                                   color: #B9B8B8;
                               }
                               .img_box {
                                   width: 50px;
                               }
                           }
                       }
                   }
               }
           }
        .biref {
            width: 100%;
            .b_title {
                width: 100%;
                color: #2767c4 ;
                font-size: 24px;
                line-height: 60px;
                border-bottom: 1px solid #D91717;
                font-weight: bold;
            }
            .user {
                width: 100%;
                display: flex;
                align-items: center;
                padding: 20px;
                .left {
                    width: 60px;
                    height: 60px;
                    border-radius: 50%;
                    overflow: hidden;
                    img {
                        width: 60px;
                        height: 60px;
                    }
                }
                .right {
                    margin-left: 20px;
                    font-size: 16px;
                    .username {
                        line-height: 30px;
                    }
                }
            }
        }


        .bottom_box {
            width: 100%;
            margin-top: 50px;
            .tuijian_title {
                font-size: 24px;
                font-weight: bold;
                color: #2767c4 ;
                padding-bottom: 10px;
                border-bottom: 1px solid #2767c4 ;
            }
            .list_content {
                margin-top: 40px;
                width: 100%;
                display: flex;
                align-items: center;
                .list_item {
                    width: 270px;
                    margin-right: 10px;
                    cursor: pointer;
                    img {
                        width: 270px;
                        height: 160px;
                    }
                    .item_title {
                        font-size: 16px;
                        padding: 10px;
                    }
                    .item_bar {
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        padding: 10px;
                        font-size: 14px;
                        color: #9B9B9B;
                    }
                }
            }
        }
    }

    
}
</style>